import { cn } from '@/lib/utils';

type IconTileSize = 'sm' | 'md' | 'lg' | 'hero';

const SIZE: Record<IconTileSize, { box: string; icon: string }> = {
  sm:   { box: 'h-7 w-7 rounded-md',   icon: '[&_svg]:h-3.5 [&_svg]:w-3.5' },
  md:   { box: 'h-10 w-10 rounded-lg', icon: '[&_svg]:h-5 [&_svg]:w-5' },
  lg:   { box: 'h-11 w-11 rounded-xl', icon: '[&_svg]:h-5 [&_svg]:w-5' },
  hero: { box: 'h-12 w-12 rounded-xl', icon: '[&_svg]:h-6 [&_svg]:w-6' },
};

type IconTileTone = 'brand' | 'brandSolid' | 'neutral';

const TONE: Record<IconTileTone, string> = {
  brand:      'bg-brand-50 text-brand-600 dark:bg-primary/10 dark:text-primary',
  brandSolid: 'bg-brand-500 text-white',
  neutral:    'bg-slate-100 text-slate-500 dark:bg-secondary dark:text-muted-foreground',
};

interface IconTileProps {
  icon: React.ReactNode;
  size?: IconTileSize;
  tone?: IconTileTone;
  className?: string;
}

export function IconTile({ icon, size = 'md', tone = 'brand', className }: IconTileProps) {
  const s = SIZE[size];
  return (
    <div className={cn('grid shrink-0 place-items-center', s.box, s.icon, TONE[tone], className)}>
      {icon}
    </div>
  );
}
